<script setup lang="ts">
// Throwaway test harness for the new clinical visit page (visit-v11), by id.
import VisitV11Page from "@/components/visit-v11/VisitV11Page.vue";

definePage({
  meta: {
    navActiveLink: "healthcare-visits",
    permissionKey: "page.healthcare.visits",
  },
});

const route = useRoute();
const visitName = computed(() => {
  const params = route.params as Record<string, string | string[] | undefined>;
  const value = params.id ?? "";

  return String(Array.isArray(value) ? value[0] : value) || "VST-V11-0001";
});
</script>

<template>
  <VisitV11Page
    :visit-name="visitName"
    mock-backend
  />
</template>
